export const handleJsonResponse = (request: Promise<Response>) => {
  return request.then(response => {
    if (!response.ok) {
      return Promise.reject(response);
    }
    return response.json();
  });
};

export const handleTextResponse = (request: Promise<Response>) => {
  return request.then(response => {
    if (!response.ok) {
      return Promise.reject(response);
    }
    return response.text();
  });
};

export const handleNoContentResponse = (request: Promise<Response>) => {
  return request.then(response => {
    if (response.status !== 204) {
      return Promise.reject(response);
    }
  });
};
